module.exports = __webpack_public_path__ + "img/product-ketang-qt-08.1e59ea42.png";